import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=21147ce8&scoped=true&"
import script from "./GeneralInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=21147ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21147ce8",
  null
  
)

export default component.exports